export default () => {
    self.addEventListener("message", event => { // eslint-disable-line no-restricted-globals
        if(!event.data) postMessage(null)
        const {datafield, val, data, chaves, changes} = event.data
        
        const newChanges = data.map(row => {
            const rowChange = changes.find(change => {
                for(let key of chaves){
                    if(change.key[key] !== row[key]){
                        return false
                    }
                }
                return true
            })
            if(rowChange){
                rowChange.data[datafield] = val
                return rowChange
            }
            else {
                const newRowChange = {}
                newRowChange.data = {
                    [datafield]: val
                }
                newRowChange.key = {}
                for(let key of chaves){
                    newRowChange.key[key] = row[key]
                }
                newRowChange.type = "update"
                return newRowChange
            }
        })

        postMessage(newChanges)
    })
}